import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reactions-summary-detail',
  templateUrl: './reactions-summary-detail.component.html',
  styleUrls: ['../reaction/reaction.component.scss', './reactions-summary-detail.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ReactionsSummaryDetailComponent implements OnInit {

  @Input() reactions: Map<string, []>;

  map: any;
  size: number=0;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    
    this.map = this.reactions;

    //this.size = this.map.HEART.length + this.map.CLAPS.length + this.map.STAR.length + this.map.YES.length + this.map.HAND.length
    if(this.map){
      for (var keys in this.map){
        console.log(this.map[keys].length)
        this.size+=this.map[keys].length
      }
    }
  }

}
